import React, { useState, useEffect } from 'react';
import { 
  FiUser, FiSearch, FiPhone, FiBriefcase, FiEdit, FiTrash2, 
  FiEye, FiPlus, FiX, FiUpload, FiLock, FiStar 
} from 'react-icons/fi';

const API_URL = 'https://app.thundermaxhome.com/api.php';

export default function EmployeesPage() {
  const [employees, setEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  // States สำหรับ Modal บัตรประจำตัวพนักงาน
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isEditingCard, setIsEditingCard] = useState(false);
  const [isNewEmployee, setIsNewEmployee] = useState(false);
  const [employeeForm, setEmployeeForm] = useState({
    uid: '', name: '', username: '', password: '', role: 'tech', department: 'ทีมช่าง', phone: '', image: '', age: '', address: '', experience: '', rating: 5, email: ''
  });

  const fetchEmployees = () => {
    setIsLoading(true);
    fetch(`${API_URL}?action=get_users`)
      .then(res => res.json())
      .then(data => { 
        setEmployees(data); 
        setIsLoading(false); 
      })
      .catch(err => { 
        console.error(err); 
        setIsLoading(false); 
      });
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setEmployeeForm(prev => ({ ...prev, image: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCreateClick = () => {
    setEmployeeForm({
      uid: '',
      name: '',
      username: '',
      password: '',
      role: 'tech',
      department: 'ทีมช่าง',
      phone: '',
      image: '',
      age: '',
      address: '',
      experience: '',
      rating: 5.0,
      email: ''
    });
    setIsNewEmployee(true);
    setIsEditingCard(true);
    setSelectedEmployee({});
  };

  const handleEditClick = (emp, isEditMode) => {
    setEmployeeForm({
      uid: emp.uid,
      name: emp.name || '',
      username: emp.username || '',
      password: '',
      role: emp.role || 'tech',
      department: emp.department || 'ทีมช่าง',
      phone: emp.phone || '',
      image: emp.image || '',
      age: emp.age || '',
      address: emp.address || '',
      experience: emp.experience || '',
      rating: emp.rating || 5.0,
      email: emp.email || ''
    });
    setIsNewEmployee(false);
    setIsEditingCard(isEditMode);
    setSelectedEmployee(emp);
  };

  const handleDeleteClick = (emp) => {
    if (window.confirm(`⚠️ คุณแน่ใจหรือไม่ที่จะลบพนักงาน ${emp.name}?\nข้อมูลทั้งหมดจะถูกลบถาวร`)) {
      fetch(`${API_URL}?action=delete_user`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid: emp.uid })
      })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          fetchEmployees();
        } else {
          alert('เกิดข้อผิดพลาด: ' + data.message);
        }
      })
      .catch(err => console.error(err));
    }
  };

  const handleSaveEmployee = () => {
    if (!employeeForm.name || !employeeForm.username) {
      alert('กรุณากรอกชื่อพนักงานและไอดีล็อกอิน (Username)');
      return;
    }
    if (isNewEmployee && !employeeForm.password) {
      alert('กรุณากรอกรหัสผ่านสำหรับสร้างพนักงานใหม่');
      return;
    }

    const actionType = isNewEmployee ? 'create_user' : 'edit_user';
    fetch(`${API_URL}?action=${actionType}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(employeeForm)
    })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        alert(isNewEmployee ? 'เพิ่มพนักงานสำเร็จ!' : 'บันทึกข้อมูลพนักงานสำเร็จ!');
        setSelectedEmployee(null);
        fetchEmployees();
      } else {
        alert('เกิดข้อผิดพลาด: ' + data.message);
      }
    })
    .catch(err => {
      console.error(err);
      alert('ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้');
    });
  };

  const filteredEmployees = employees.filter(e => 
    (e.name?.toLowerCase().includes(searchTerm.toLowerCase())) || 
    (e.department?.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <div className="space-y-6 pb-10 text-left">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-black text-gray-800 dark:text-white transition-colors">👨‍🔧 ฐานข้อมูลพนักงาน</h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 transition-colors">ทำเนียบรายชื่อพนักงาน เบอร์ติดต่อ และแผนกที่สังกัด</p>
        </div>
        <button
          onClick={handleCreateClick}
          className="px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-bold shadow-md hover:shadow-lg transition-all flex items-center gap-1.5 border-none cursor-pointer"
        >
          <FiPlus size={16} /> เพิ่มพนักงานใหม่
        </button>
      </div>

      <div className="bg-white dark:bg-[#1e293b] rounded-xl border border-gray-200 dark:border-[#334155] shadow-sm dark:shadow-lg transition-colors overflow-hidden">
        
        {/* แถบค้นหา */}
        <div className="p-4 border-b border-gray-200 dark:border-[#334155] flex flex-col sm:flex-row justify-between items-center gap-4 bg-gray-50 dark:bg-[#0f172a]/50">
          <div className="relative w-full sm:w-96">
            <FiSearch className="absolute left-3 top-3 text-gray-400" />
            <input 
              type="text" 
              placeholder="ค้นหาชื่อพนักงาน หรือ แผนก..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 bg-white dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-sm text-gray-800 dark:text-white outline-none focus:border-blue-500 transition-colors"
            />
          </div>
          <div className="text-sm font-bold text-gray-500 dark:text-gray-400">
            พนักงานทั้งหมด: <span className="text-blue-600 dark:text-blue-400">{filteredEmployees.length}</span> คน
          </div>
        </div>

        {/* ตารางพนักงาน */}
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm text-gray-700 dark:text-gray-300">
            <thead className="text-xs uppercase bg-gray-100 dark:bg-[#0f172a] text-gray-600 dark:text-gray-400 border-b border-gray-200 dark:border-[#334155] transition-colors">
              <tr>
                <th className="px-4 py-4 font-medium">ชื่อพนักงาน</th>
                <th className="px-4 py-4 font-medium">เบอร์โทรศัพท์</th>
                <th className="px-4 py-4 font-medium">แผนก / สังกัด</th>
                <th className="px-4 py-4 font-medium">ระดับสิทธิ์ (Role)</th>
                <th className="px-4 py-4 font-medium text-right">การจัดการ</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-[#334155] transition-colors">
              {isLoading ? (
                <tr><td colSpan="5" className="text-center py-10">กำลังโหลดข้อมูล...</td></tr>
              ) : filteredEmployees.length > 0 ? filteredEmployees.map((emp, index) => (
                <tr key={index} className="hover:bg-gray-50 dark:hover:bg-[#0f172a]/50 transition-colors">
                  <td className="px-4 py-4 font-bold text-gray-900 dark:text-white">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-gray-200 dark:bg-[#334155] flex items-center justify-center overflow-hidden text-gray-500 dark:text-gray-400">
                        {emp.image ? (
                          <img src={emp.image} className="w-full h-full object-cover" alt="" />
                        ) : (
                          <FiUser size={16} />
                        )}
                      </div>
                      <div>
                        {emp.name}
                        <div className="text-[10px] text-gray-400 font-normal mt-0.5">Username: {emp.username}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    {emp.phone && emp.phone !== '-' ? (
                      <a href={`tel:${emp.phone}`} className="flex items-center gap-1.5 text-blue-600 dark:text-blue-400 hover:underline font-bold">
                        <FiPhone size={12}/> {emp.phone}
                      </a>
                    ) : (
                      <span className="text-gray-400">-</span>
                    )}
                  </td>
                  <td className="px-4 py-4">
                    <div className="flex items-center gap-1.5 text-gray-600 dark:text-gray-300 font-medium">
                      <FiBriefcase size={14} className="text-gray-400" />
                      {emp.department || 'ทีมช่างซ่อม'}
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <span className="bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 px-3 py-1 rounded-lg text-xs font-bold border border-blue-100 dark:border-blue-800/50">
                      {emp.role === 'admin' ? 'แอดมิน' : emp.role === 'tech' ? 'ช่างซ่อม' : emp.role === 'it' ? 'ไอที' : emp.role}
                    </span>
                  </td>
                  <td className="px-4 py-4 text-right">
                    <div className="flex justify-end gap-2">
                      <button
                        onClick={() => handleEditClick(emp, false)}
                        className="p-2 bg-gray-100 hover:bg-gray-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-gray-700 dark:text-gray-300 rounded-lg cursor-pointer border-none transition-colors"
                        title="ดูบัตรประจำตัว"
                      >
                        <FiEye size={14} />
                      </button>
                      <button
                        onClick={() => handleEditClick(emp, true)}
                        className="p-2 bg-blue-50 hover:bg-blue-100 dark:bg-blue-900/20 dark:hover:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-lg cursor-pointer border-none transition-colors"
                        title="แก้ไขพนักงาน"
                      >
                        <FiEdit size={14} />
                      </button>
                      <button
                        onClick={() => handleDeleteClick(emp)}
                        className="p-2 bg-red-50 hover:bg-red-100 dark:bg-red-950/20 dark:hover:bg-red-950/30 text-red-600 dark:text-red-400 rounded-lg cursor-pointer border-none transition-colors"
                        title="ลบพนักงาน"
                      >
                        <FiTrash2 size={14} />
                      </button>
                    </div>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan="5" className="text-center py-10 text-gray-500">ไม่พบข้อมูลพนักงาน</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* --- Modal บัตรประจำตัวพนักงาน --- */}
      {selectedEmployee && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[95] flex items-center justify-center p-4">
          <div className="bg-white dark:bg-[#1e293b] rounded-3xl w-full max-w-3xl overflow-hidden shadow-2xl border-0 animate-in zoom-in-95 duration-200 flex flex-col md:flex-row max-h-[90vh] text-gray-900 dark:text-white">
            
            {/* Left side: Card preview */}
            <div className="flex flex-col items-center justify-center p-6 bg-gray-50 dark:bg-[#0f172a] border-r border-gray-200 dark:border-[#334155] shrink-0 select-none">
              {/* Lanyard/Clip representation */}
              <div className="w-12 h-4 bg-gray-300 dark:bg-gray-700 rounded-md relative shadow-inner mb-2 flex items-center justify-center">
                <div className="w-6 h-6 rounded-full bg-gray-400 dark:bg-gray-600 border border-gray-300 dark:border-gray-800 absolute -top-3 flex items-center justify-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-gray-600 dark:bg-gray-900"></div>
                </div>
                <div className="w-4 h-1.5 bg-gray-800 dark:bg-gray-950 rounded-full mt-1.5"></div>
              </div>

              {/* ID Card Graphic Container */}
              <div className="w-64 h-[24rem] rounded-2xl border-2 shadow-2xl relative overflow-hidden flex flex-col justify-between bg-white dark:bg-[#1e293b] border-gray-200 dark:border-[#334155] text-gray-900 dark:text-white">
                {/* Top Header Block */}
                <div className="h-16 bg-gradient-to-r from-blue-600 to-indigo-600 p-3 text-center flex flex-col justify-center items-center relative">
                  <span className="text-[10px] text-blue-100 font-black uppercase tracking-widest">THUNDER MAXHOME</span>
                  <span className="text-[8px] text-white/70 font-bold uppercase tracking-wider mt-0.5">OFFICIAL ACCESS PASS</span>
                  <div className="absolute -bottom-2 w-4 h-4 bg-inherit transform rotate-45"></div>
                </div>

                {/* Profile Picture */}
                <div className="flex flex-col items-center mt-4 relative">
                  <div className="w-28 h-28 rounded-full overflow-hidden border-4 border-white dark:border-[#1e293b] bg-gray-100 dark:bg-[#0f172a] shadow-md relative group">
                    {employeeForm.image ? (
                      <img src={employeeForm.image} className="w-full h-full object-cover" alt="" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-gray-400">
                        <FiUser size={48} />
                      </div>
                    )}
                    {isEditingCard && (
                      <label className="absolute inset-0 bg-black/60 cursor-pointer flex flex-col items-center justify-center text-white text-[8px] font-black opacity-0 group-hover:opacity-100 transition-opacity">
                        <FiUpload size={14} className="mb-0.5" />
                        เปลี่ยนรูป
                        <input type="file" accept="image/*" onChange={handleImageUpload} className="sr-only" />
                      </label>
                    )}
                  </div>
                </div>

                {/* Details */}
                <div className="p-4 text-center space-y-1 flex-1 flex flex-col justify-center">
                  <h3 className="text-base font-black truncate max-w-[220px] mx-auto tracking-wide">
                    {employeeForm.name || 'ชื่อ-นามสกุล พนักงาน'}
                  </h3>
                  <div className="inline-block px-2.5 py-0.5 bg-blue-500/10 text-blue-500 rounded-full border border-blue-500/20 text-[9px] font-black uppercase tracking-wider mx-auto">
                    {employeeForm.role === 'tech' ? 'ช่างซ่อม' : employeeForm.role === 'admin' ? 'แอดมิน' : employeeForm.role === 'it' ? 'ไอที' : employeeForm.role}
                  </div>

                  <div className="pt-2 text-[8px] font-bold text-gray-400 dark:text-gray-500 flex justify-center gap-3">
                    <span>อายุ: {employeeForm.age ? `${employeeForm.age} ปี` : '-'}</span>
                    <span>เบอร์โทร: {employeeForm.phone || '-'}</span>
                  </div>

                  <div className="flex justify-center items-center gap-1 text-[10px] font-black text-amber-500 mt-1">
                    <FiStar className="fill-amber-500 inline" size={10} /> {Number(employeeForm.rating || 5).toFixed(1)} / 5.0
                  </div>
                </div>

                {/* Barcode & ID at bottom */}
                <div className="p-3 bg-gray-50 dark:bg-[#0f172a]/50 border-t border-inherit flex flex-col items-center justify-center shrink-0">
                  <div className="flex gap-0.5 items-end justify-center mb-1 select-none">
                    {[1, 3, 2, 4, 1, 2, 3, 1, 4, 2, 1, 3, 2, 4, 1, 2, 1, 3, 4, 1, 2, 3].map((val, idx) => (
                      <div key={idx} className="bg-gray-900 dark:bg-gray-300 rounded-sm" style={{ width: `${val * 0.7}px`, height: '14px' }}></div>
                    ))}
                  </div>
                  <span className="text-[8px] font-mono font-bold tracking-widest text-gray-500 dark:text-gray-400 uppercase">
                    * {employeeForm.uid || 'NEW_USER'} *
                  </span>
                </div>
              </div>
            </div>

            {/* Right side: Form or view details */}
            <div className="flex-1 p-6 flex flex-col max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center border-b pb-4 mb-4 dark:border-[#334155]">
                <h3 className="text-base font-black">
                  {isEditingCard ? (isNewEmployee ? '➕ เพิ่มพนักงานใหม่' : '✏️ แก้ไขข้อมูลพนักงาน') : '👤 บัตรพนักงาน (Employee Access Card)'}
                </h3>
                <button 
                  onClick={() => setSelectedEmployee(null)} 
                  className="p-1.5 rounded-full bg-gray-100 hover:bg-gray-200 dark:bg-[#334155] dark:hover:bg-[#475569] text-gray-500 dark:text-gray-300 transition border-none cursor-pointer"
                >
                  <FiX size={16}/>
                </button>
              </div>

              {isEditingCard ? (
                // Edit Form View
                <div className="space-y-4 text-left font-bold text-xs">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-gray-500 dark:text-gray-400 mb-1">ชื่อพนักงาน</label>
                      <input 
                        type="text" 
                        placeholder="เช่น สมชาย ใจดี" 
                        value={employeeForm.name} 
                        onChange={e => setEmployeeForm({ ...employeeForm, name: e.target.value })} 
                        className="w-full px-3 py-2 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs font-bold text-gray-800 dark:text-white outline-none focus:border-blue-500"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-500 dark:text-gray-400 mb-1">ไอดีล็อกอิน (Username)</label>
                      <input 
                        type="text" 
                        placeholder="เช่น somchai_s" 
                        value={employeeForm.username} 
                        disabled={!isNewEmployee}
                        onChange={e => setEmployeeForm({ ...employeeForm, username: e.target.value })} 
                        className={`w-full px-3 py-2 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs font-bold text-gray-800 dark:text-white outline-none focus:border-blue-500 ${!isNewEmployee ? 'opacity-50 cursor-not-allowed' : ''}`}
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-gray-500 dark:text-gray-400 mb-1">
                        {isNewEmployee ? 'รหัสผ่าน (Password)' : 'เปลี่ยนรหัสผ่าน (เว้นว่างไว้เพื่อคงเดิม)'}
                      </label>
                      <input 
                        type="password" 
                        placeholder="รหัสผ่าน" 
                        value={employeeForm.password} 
                        onChange={e => setEmployeeForm({ ...employeeForm, password: e.target.value })} 
                        className="w-full px-3 py-2 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs font-bold text-gray-800 dark:text-white outline-none focus:border-blue-500"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-500 dark:text-gray-400 mb-1">ระดับสิทธิ์ (Role)</label>
                      <select 
                        value={employeeForm.role} 
                        onChange={e => setEmployeeForm({ ...employeeForm, role: e.target.value })} 
                        className="w-full px-3 py-2 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs font-bold text-gray-800 dark:text-white outline-none focus:border-blue-500 cursor-pointer"
                      >
                        <option value="tech">ช่างซ่อม (Technician)</option>
                        <option value="admin">แอดมิน (Admin)</option>
                        <option value="it">ไอที (IT Support)</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-3">
                    <div>
                      <label className="block text-gray-500 dark:text-gray-400 mb-1">อายุ (ปี)</label>
                      <input 
                        type="number" 
                        placeholder="25" 
                        value={employeeForm.age} 
                        onChange={e => setEmployeeForm({ ...employeeForm, age: e.target.value })} 
                        className="w-full px-3 py-2 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs font-bold text-gray-800 dark:text-white outline-none focus:border-blue-500"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-500 dark:text-gray-400 mb-1">แผนก / สังกัด</label>
                      <input 
                        type="text" 
                        placeholder="เช่น ทีมช่างซ่อม" 
                        value={employeeForm.department} 
                        onChange={e => setEmployeeForm({ ...employeeForm, department: e.target.value })} 
                        className="w-full px-3 py-2 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs font-bold text-gray-800 dark:text-white outline-none focus:border-blue-500"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-500 dark:text-gray-400 mb-1">คะแนนรีวิวลูกค้า (0.0-5.0)</label>
                      <input 
                        type="number" 
                        step="0.1" 
                        min="0" 
                        max="5" 
                        placeholder="5.0" 
                        value={employeeForm.rating} 
                        onChange={e => setEmployeeForm({ ...employeeForm, rating: e.target.value })} 
                        className="w-full px-3 py-2 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs font-bold text-gray-800 dark:text-white outline-none focus:border-blue-500"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-gray-500 dark:text-gray-400 mb-1">เบอร์โทรศัพท์</label>
                      <input 
                        type="tel" 
                        placeholder="เช่น 0891234567" 
                        value={employeeForm.phone} 
                        onChange={e => setEmployeeForm({ ...employeeForm, phone: e.target.value })} 
                        className="w-full px-3 py-2 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs font-bold text-gray-800 dark:text-white outline-none focus:border-blue-500"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-500 dark:text-gray-400 mb-1">อีเมลพนักงาน (รับงาน/เตือน EmailJS)</label>
                      <input 
                        type="email" 
                        placeholder="เช่น employee@email.com" 
                        value={employeeForm.email || ''} 
                        onChange={e => setEmployeeForm({ ...employeeForm, email: e.target.value })} 
                        className="w-full px-3 py-2 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs font-bold text-gray-800 dark:text-white outline-none focus:border-blue-500"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-gray-500 dark:text-gray-400 mb-1">ที่อยู่ปัจจุบัน</label>
                    <textarea 
                      rows="2" 
                      placeholder="ป้อนข้อมูลที่อยู่พนักงาน..." 
                      value={employeeForm.address} 
                      onChange={e => setEmployeeForm({ ...employeeForm, address: e.target.value })} 
                      className="w-full p-3 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs font-medium text-gray-850 dark:text-white outline-none focus:border-blue-500 resize-none"
                    ></textarea>
                  </div>

                  <div>
                    <label className="block text-gray-500 dark:text-gray-400 mb-1">ประวัติการทำงาน / บันทึกย่อ</label>
                    <textarea 
                      rows="2" 
                      placeholder="ป้อนประวัติ ประสบการณ์ บันทึกย่อพนักงาน..." 
                      value={employeeForm.experience} 
                      onChange={e => setEmployeeForm({ ...employeeForm, experience: e.target.value })} 
                      className="w-full p-3 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs font-medium text-gray-850 dark:text-white outline-none focus:border-blue-500 resize-none"
                    ></textarea>
                  </div>

                  <div className="border-t pt-4 mt-2 flex gap-3.5 dark:border-[#334155]">
                    <button 
                      onClick={handleSaveEmployee} 
                      className="flex-1 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-black text-xs transition cursor-pointer active:scale-95 shadow-sm border-none"
                    >
                      💾 บันทึกข้อมูล
                    </button>
                    <button 
                      onClick={() => {
                        if (isNewEmployee) setSelectedEmployee(null);
                        else setIsEditingCard(false);
                      }} 
                      className="flex-1 py-3 bg-gray-200 hover:bg-gray-300 dark:bg-slate-700 dark:hover:bg-slate-600 text-gray-700 dark:text-gray-200 rounded-xl font-black text-xs transition cursor-pointer border-none"
                    >
                      ยกเลิก
                    </button>
                  </div>
                </div>
              ) : (
                // Read-Only Detail View
                <div className="space-y-4 text-left text-xs flex-grow flex flex-col justify-between">
                  <div className="space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <span className="block text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-1">รหัสบัญชีพนักงาน (UID)</span>
                        <div className="font-mono text-xs font-black p-2.5 bg-gray-50 dark:bg-[#0f172a] rounded-xl border border-gray-100 dark:border-gray-800">
                          {employeeForm.uid}
                        </div>
                      </div>
                      <div>
                        <span className="block text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-1">สังกัด / แผนก</span>
                        <div className="text-xs font-black p-2.5 bg-gray-50 dark:bg-[#0f172a] rounded-xl border border-gray-100 dark:border-gray-800 text-blue-600 dark:text-blue-400">
                          {employeeForm.department}
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-4 gap-2">
                      <div>
                        <span className="block text-[9px] text-gray-400 font-bold uppercase tracking-wider mb-1">อายุ</span>
                        <div className="font-bold p-2.5 bg-gray-50 dark:bg-[#0f172a] rounded-xl border border-gray-100 dark:border-gray-800 truncate">
                          {employeeForm.age ? `${employeeForm.age} ปี` : '-'}
                        </div>
                      </div>
                      <div>
                        <span className="block text-[9px] text-gray-400 font-bold uppercase tracking-wider mb-1">เบอร์โทร</span>
                        <div className="font-bold p-2.5 bg-gray-50 dark:bg-[#0f172a] rounded-xl border border-gray-100 dark:border-gray-800 truncate">
                          {employeeForm.phone || '-'}
                        </div>
                      </div>
                      <div>
                        <span className="block text-[9px] text-gray-400 font-bold uppercase tracking-wider mb-1">อีเมล</span>
                        <div className="font-bold p-2.5 bg-gray-50 dark:bg-[#0f172a] rounded-xl border border-gray-100 dark:border-gray-800 truncate" title={employeeForm.email}>
                          {employeeForm.email || '-'}
                        </div>
                      </div>
                      <div>
                        <span className="block text-[9px] text-gray-400 font-bold uppercase tracking-wider mb-1">Username</span>
                        <div className="font-mono font-black p-2.5 bg-gray-50 dark:bg-[#0f172a] rounded-xl border border-gray-100 dark:border-gray-800 text-emerald-600 dark:text-emerald-400 truncate">
                          {employeeForm.username}
                        </div>
                      </div>
                    </div>

                    <div>
                      <span className="block text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-1">ที่อยู่ปัจจุบัน</span>
                      <div className="p-3 bg-gray-50 dark:bg-[#0f172a] rounded-xl border border-gray-100 dark:border-gray-800 font-medium whitespace-pre-line text-xs leading-relaxed">
                        {employeeForm.address || 'ไม่มีข้อมูลที่อยู่'}
                      </div>
                    </div>

                    <div>
                      <span className="block text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-1">ประวัติการทำงาน / บันทึกย่อ</span>
                      <div className="p-3 bg-gray-50 dark:bg-[#0f172a] rounded-xl border border-gray-100 dark:border-gray-800 font-medium whitespace-pre-line text-xs leading-relaxed">
                        {employeeForm.experience || 'ไม่มีข้อมูลประวัติการทำงาน'}
                      </div>
                    </div>
                  </div>

                  <div className="border-t pt-4 mt-4 flex gap-3 dark:border-[#334155] shrink-0">
                    <button 
                      onClick={() => setIsEditingCard(true)} 
                      className="flex-1 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-black text-xs transition cursor-pointer active:scale-95 shadow-sm border-none"
                    >
                      ✏️ แก้ไขข้อมูลบัตร
                    </button>
                    <button 
                      onClick={() => setSelectedEmployee(null)} 
                      className="flex-1 py-3 bg-gray-100 hover:bg-gray-250 dark:bg-slate-700 dark:hover:bg-slate-600 text-gray-700 dark:text-gray-200 rounded-xl font-black text-xs transition cursor-pointer border-none"
                    >
                      ปิดหน้าต่าง
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}